export default "__VITE_ASSET__Dikl4iN7__"